import { relations } from 'drizzle-orm'
import { index, pgTable, text } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getIdReference,
  getMonetaryField,
  getNullableIdReference,
  getTimestampWithTimezone,
} from '../common/utils'
import { invoices } from './invoice'
import { users } from './user'

export const invoicePayments = pgTable(
  'invoice_payments',
  {
    ...getBaseFields(),
    invoiceId: getIdReference(() => invoices.id),
    amount: getMonetaryField().notNull(), // Payment amount in euros
    paidAt: getTimestampWithTimezone().notNull(), // Payment date from KTL
    archiveId: text().notNull().unique(), // Bank's archive ID - unique for idempotency
    referenceNumber: text().notNull(), // Original reference from KTL (for audit trail)
    payerName: text(), // From KTL (12 chars, may be truncated)
    importedAt: getTimestampWithTimezone().notNull().defaultNow(),
    importedByUserId: getNullableIdReference(() => users.id),
  },
  (table) => [
    ...getBaseIndexes('invoice_payments', table),
    index('invoice_payments_invoice_id_idx').on(table.invoiceId),
  ],
)

export const invoicePaymentsRelations = relations(
  invoicePayments,
  ({ one }) => ({
    invoice: one(invoices, {
      fields: [invoicePayments.invoiceId],
      references: [invoices.id],
    }),
    importedByUser: one(users, {
      fields: [invoicePayments.importedByUserId],
      references: [users.id],
    }),
  }),
)
